import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./chip.html";
class Chip extends LightningElement {
  constructor(...args) {
    super(...args);
    this.chip = void 0;
  }
  handleInputKeyDown(event) {
    if (event.key === ' ') {
      event.preventDefault();
      this.handleClose();
    }
  }
  handleClose() {
    this.dispatchEvent(new CustomEvent('close', {
      detail: {
        value: this.chip.value,
        section: this.chip.section
      }
    }));
    const clickEvent = new CustomEvent('analytics', {
      bubbles: true,
      composed: true,
      detail: {
        eventType: 'click',
        elementType: 'chip',
        value: this.chip.value,
        section: this.chip.section
      }
    });
    this.dispatchEvent(clickEvent);
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Chip, {
  publicProps: {
    chip: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(Chip, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;